import { render, staticRenderFns } from "./Base-Wrapper.vue?vue&type=template&id=22867ad0&"
import script from "./Base-Wrapper.vue?vue&type=script&lang=js&"
export * from "./Base-Wrapper.vue?vue&type=script&lang=js&"
import style0 from "./Base-Wrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports